<template>
  <ExpenseFeeToolbar
    :filter-options="filterOptions"
    :search-placeholder="text.toolbar.searchPlaceholder"
    inline-filter-key="provider"
    :first-row-keys="['customer', 'expense_class', 'category']"
    :second-row-keys="['tags', 'has_xml', 'currency', 'area']"
    :filter-configs="filterConfigs"
    :all-option-labels="text.toolbar.allOptionLabels"
    :selection-all-labels="text.toolbar.selectionAllLabels"
    :empty-option-text="text.toolbar.emptyOption"
    :filters-button-title="text.toolbar.filtersButtonTitle"
    :search-button-title="text.toolbar.searchButtonTitle"
    :date-range-presets="text.toolbar.dateRangePresets"
    :first-row-columns="3"
    :second-row-columns="4"
    @search-change="$emit('search-change', $event)"
    @filters-change="handleFiltersChange"
    @apply="$emit('apply', $event)"
  />
</template>

<script>
import ExpenseFeeToolbar from '@/components/expensesFees/ExpenseFeeToolbar.vue';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('expenses');

export default {
  name: 'ExpensesToolbar',
  components: {
    ExpenseFeeToolbar,
  },
  props: {
    filterOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['search-change', 'filters-change', 'apply'],
  data() {
    return {
      text,
      filterConfigs: [
        { key: 'provider', label: text.toolbar.filters.provider.label, placeholder: text.toolbar.filters.provider.placeholder, searchable: text.toolbar.filters.provider.searchable },
        { key: 'expense_class', label: text.toolbar.filters.expenseClass.label, placeholder: text.toolbar.filters.expenseClass.placeholder, searchable: text.toolbar.filters.expenseClass.searchable },
        { key: 'category', label: text.toolbar.filters.category.label, placeholder: text.toolbar.filters.category.placeholder, searchable: text.toolbar.filters.category.searchable },
        { key: 'customer', label: text.toolbar.filters.customer.label, placeholder: text.toolbar.filters.customer.placeholder, searchable: text.toolbar.filters.customer.searchable },
        { key: 'tags', label: text.toolbar.filters.tags.label, placeholder: text.toolbar.filters.tags.placeholder, searchable: text.toolbar.filters.tags.searchable },
        { key: 'has_xml', label: text.toolbar.filters.hasXml.label, placeholder: text.toolbar.filters.hasXml.placeholder, searchable: text.toolbar.filters.hasXml.searchable },
        { key: 'currency', label: text.toolbar.filters.currency.label, placeholder: text.toolbar.filters.currency.placeholder, searchable: text.toolbar.filters.currency.searchable },
        { key: 'area', label: text.toolbar.filters.area.label, placeholder: text.toolbar.filters.area.placeholder, searchable: text.toolbar.filters.area.searchable },
      ],
    };
  },
  methods: {
    handleFiltersChange(payload, meta) {
      this.$emit('filters-change', payload, meta);
    },
  },
};
</script>
